import { useEffect } from 'react';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';
import { useEntraUserToken } from './useEntraToken';

// This is a custom field extension for the Scaffolder plugin that fetches a
// Microsoft/Entra user token and stores it in the template secrets context
// under the 'USER_OAUTH_ENTRA_TOKEN' key. This field extension has no UI.
export const EntraUserToken = () => {
  const SECRET_NAME = 'USER_OAUTH_ENTRA_TOKEN';
  const { setSecrets } = useTemplateSecrets();
  const { token } = useEntraUserToken();
  useEffect(() => {
    if (token) {
      setSecrets({ [SECRET_NAME]: token });
    }
  }, [token, setSecrets]);

  // This field extension does not render any UI
  return <></>;
};
